/*
 * File: /src/store/modules/aiContextConfigs.js
 * Author: AdBase, Inc.
 * Copyright (c) 2026 AdBase, Inc.
 */

import AiContextTypeService from 'src/services/aiContextTypeService';

const state = {
  aiContextConfigs: undefined
};

const getters = {
  getAiContextConfigs: state => state.aiContextConfigs
};

const actions = {
  async fetchAiContextConfigs({ commit, state }) {
    // Only load the data once
    if (state.aiContextConfigs == undefined) {
      return AiContextTypeService.getConfigs()
        .then(r => {
          // The API may hand back the bare list or wrap it in configs
          const data = r.data;
          commit('setAiContextConfigs', Array.isArray(data) ? data : data?.configs || []);
        });
    }
  },
  unloadAiContextConfigs({ commit }) {
    commit('setAiContextConfigs', undefined);
  },
};

const mutations = {
  setAiContextConfigs(state, aiContextConfigs) {
    state.aiContextConfigs = aiContextConfigs;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
